<script setup>

</script>

<template>
     <div class="announcement">
        <div class="announcement_wrapper">
          <div class="announcement__info">
              <div class="announcement__info_btn btn btn_note">
                  <svg width="12" height="8"class="icon icon_eye">
                      <use xlink:href="#eye"></use>
                  </svg>
                  <div class="announcement__info_btn_text">
                    <slot name="announcement__info_btn_text">
                    </slot>
                  </div>
              </div>
              <div class="announcement__info_text">
                <slot name="announcement__info_text">
                </slot>
              </div>
          </div>
          <div class="announcement__img">
              <svg class="icon icon_feather">
                  <use xlink:href="#feather"></use>
              </svg>
          </div>
        </div>
      <div class="announcement__underline"></div>
    </div>
</template>

<style lang="scss">
</style>